(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "@better-scroll/core", "@better-scroll/scroll-bar", "@better-scroll/observe-dom", "../_mixins/osProps", "../popup", "../_mixins/sheetsBounce", "../_util", "../_mixins/resizeOb"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("@better-scroll/core"), require("@better-scroll/scroll-bar"), require("@better-scroll/observe-dom"), require("../_mixins/osProps"), require("../popup"), require("../_mixins/sheetsBounce"), require("../_util"), require("../_mixins/resizeOb"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.core, global.scrollBar, global.observeDom, global.osProps, global.popup, global.sheetsBounce, global._util, global.resizeOb);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _core, _scrollBar, _observeDom, _osProps, _popup, _sheetsBounce, _util, _resizeOb) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _core = _interopRequireDefault(_core);
  _scrollBar = _interopRequireDefault(_scrollBar);
  _observeDom = _interopRequireDefault(_observeDom);
  _osProps = _interopRequireDefault(_osProps);
  _popup = _interopRequireDefault(_popup);
  _sheetsBounce = _interopRequireDefault(_sheetsBounce);

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  _core.default.use(_scrollBar.default);

  _core.default.use(_observeDom.default);

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        class: {
          'nx-sheets-fixed': true,
          'nx-os-blur-material': _vm.blurMaterial
        }
      }, [_c('nx-popup', {
        ref: "bounceDialog",
        class: {
          'nx-sheets-small': _vm.mode === 'small',
          'nx-sheets-middle': _vm.mode === 'middle',
          'nx-sheets-big': _vm.mode === 'large'
        },
        attrs: {
          "mode": _vm.mode,
          "maskClosable": _vm.maskClosable,
          "slideDownDisappear": _vm.slideDownDisappear,
          "backClosePopup": _vm.backClosePopup,
          "pluginModule": 'sheets',
          "is-webview-full": _vm.isWebviewFull,
          "multiplePopup": _vm.multiplePopup,
          "backClosePopupCustomEvent": _vm.backClosePopupCustomEvent,
          "position": "sheets-bottom"
        },
        on: {
          "input": function input($event) {
            return _vm.$emit('input', false);
          },
          "beforeShow": _vm.$_onbeforeShow,
          "show": _vm.$_onShow,
          "hide": _vm.$_onHide,
          "maskClick": _vm.$_maskClick,
          "leftIconClick": _vm.$_leftIconClick
        },
        model: {
          value: _vm.isPopupShow,
          callback: function callback($$v) {
            _vm.isPopupShow = $$v;
          },
          expression: "isPopupShow"
        }
      }, [_c('div', {
        staticClass: "sheets-title",
        class: {
          'vscroll-title': _vm.vscroll
        }
      }, [_c('div', {
        staticClass: "title-left"
      }, [_vm._t("left"), !_vm.$slots.left && _vm.leftIcon ? _c('img', {
        staticClass: "nx-sheets-fixed-left-icon",
        attrs: {
          "src": _vm.leftIcon,
          "aria-label": _vm.ariaLabelLeftIcon || '按钮',
          "alt": "",
          "role": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.$_leftIconClick();
          }
        }
      }) : _vm._e()], 2), _c('div', {
        staticClass: "title",
        on: {
          "touchstart": _vm.handleTouchstart,
          "touchmove": _vm.handleTouchmove,
          "touchend": function touchend($event) {
            return _vm.handleTouchend(_vm.hidePopUp);
          }
        }
      }, [_c('div', {
        style: _vm.sheetsTitleStyle,
        attrs: {
          "nx-popup-aria-auto-focus": "true",
          "aria-label": _vm.sheetsTitle
        }
      }, [_vm._v("\n          " + _vm._s(_vm.sheetsTitle) + "\n        ")])]), _vm.showCancelIcon ? _c('img', {
        staticClass: "nx-sheets-fixed-right-icon",
        attrs: {
          "src": "https://gaia-vivofs.vivo.com.cn/qEiqKoT2I4DBQpyI/13937e30-2144-11ee-88e2-1bb1cf1d109f.png",
          "aria-label": "关闭",
          "alt": "",
          "role": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.hidePopUp();
          }
        }
      }) : _vm._e()]), _c('div', {
        staticClass: "nx-sheets-fixed-content"
      }, [_vm.vscroll ? [_c('div', {
        ref: "scroll-bar",
        staticClass: "content-slot scroll-bar"
      }, [_c('div', {
        ref: "scroll-content"
      }, [_vm._t("default")], 2)])] : [_c('div', {
        staticClass: "content-slot"
      }, [_vm._t("default")], 2)], _c('div', {
        staticClass: "bottom-slot"
      }, [_vm._t("bottom")], 2)], 2)])], 1);
    },
    name: 'nx-sheets-fixed',
    mixins: [_sheetsBounce.default, _resizeOb.resizeOb, _osProps.default],
    components: (0, _defineProperty2.default)({}, _popup.default.name, _popup.default),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      mode: {
        type: String,
        default: 'large'
      },
      sheetsTitle: {
        type: String,
        default: ''
      },
      sheetsTitleStyle: {
        type: Object
      },
      leftIcon: {
        type: String,
        default: ''
      },
      maskClosable: {
        type: Boolean,
        default: true
      },
      showCancelIcon: {
        type: Boolean,
        default: true
      },
      slideDownDisappear: {
        default: undefined
      },
      backClosePopup: {
        type: Boolean,
        default: false
      },
      backClosePopupCustomEvent: {
        type: String,
        default: 'popstate'
      },
      ariaLabelLeftIcon: {
        type: String,
        default: ''
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          if (_util.isCombineWallet && location.href && location.href.indexOf('sink=1') > -1) {
            return true;
          } else {
            return false;
          }
        }
      },
      multiplePopup: {
        type: Boolean,
        default: false
      },
      appendToBody: {
        type: Boolean,
        default: false
      },
      vscroll: {
        type: Boolean,
        default: false
      },
      bScrollProps: {
        type: Object,
        default: function _default() {
          return {};
        }
      }
    },
    data: function data() {
      return {
        isPopupShow: this.value,
        bodyscroll: null
      };
    },
    watch: {
      value: function value(val) {
        this.isPopupShow = val;
      }
    },
    computed: {},
    mounted: function mounted() {
      var _this = this;

      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }

      if (this.vscroll) {
        this.$nextTick(function () {
          _this.bodyscroll = new _core.default(_this.$refs['scroll-bar'], _objectSpread({
            click: true,
            bindToWrapper: !!_this.isWebviewFull,
            deceleration: 0.002,
            scrollY: true,
            observeDOM: true,
            swipeBounceTime: 200,
            scrollbar: {
              fade: true,
              fadeInTime: 300,
              fadeOutTime: 300
            }
          }, _this.bScrollProps)); // 如果内容是异步加载的，则需要监听高度变化，重新刷新

          _this.$obReInit({
            el: _this.$refs['scroll-content'],
            cbHeight: function cbHeight() {
              if (_this.timer) {
                clearTimeout(_this.timer);
                _this.timer = null;
              }

              _this.timer = setTimeout(function () {
                _this.$_onRefresh();
              }, 300);
            },
            unLimitResizeObNum: true
          });
        });
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.vscroll) {
        var _this$bodyscroll;

        (_this$bodyscroll = this.bodyscroll) === null || _this$bodyscroll === void 0 ? void 0 : _this$bodyscroll.destroy();
        this.bodyscroll = null;
      }

      if (this.appendToBody) {
        document.body.removeChild(this.$el);
      }
    },
    methods: {
      hidePopUp: function hidePopUp() {
        this.isPopupShow = false;
        this.$emit('cancel');
      },
      $_onbeforeShow: function $_onbeforeShow() {
        this.$emit('beforeShow');
      },
      $_onShow: function $_onShow() {
        this.$emit('show');
        this.$_onRefresh();
      },
      $_onRefresh: function $_onRefresh() {
        var _this2 = this;

        this.$nextTick(function () {
          var _this2$bodyscroll;

          (_this2$bodyscroll = _this2.bodyscroll) === null || _this2$bodyscroll === void 0 ? void 0 : _this2$bodyscroll.refresh();
        });
      },
      $_onHide: function $_onHide() {
        this.$emit('hide');
      },
      $_maskClick: function $_maskClick() {
        this.$emit('maskClick');
      },
      $_leftIconClick: function $_leftIconClick() {
        this.$emit('leftIconClick');
      }
    }
  };
  _exports.default = _default2;
});